export default "__VITE_ASSET__DJZiUqVO__"